// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#filterContainer > .row > div {\r\n  padding-bottom: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.container-data-filter-info {\r\n    max-width: 100%;\r\n}\r\n\r\n.container-data-filter-buttons {\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n}\r\n\r\n.form-field-name {\r\n  color: rgba(0, 0, 0, 0.4);\r\n  font-size: 15px;\r\n}\r\n\r\n.form-field-value {\r\n}\r\n\r\n.details-list {\r\n  max-height: calc(100vh - 200px);\r\n  overflow-y: auto;\r\n}", ""]);
// Exports
module.exports = exports;
